<template>
  <div>
    <el-form :inline="true" :model="searchForm"  size="medium">
      <el-form-item label="会话时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.timeZone" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" size="medium">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="searchForm.region">
          <el-option label="东区" :value="0"></el-option>
          <el-option label="南区" :value="1"></el-option>
          <el-option label="西区" :value="2"></el-option>
          <el-option label="北区" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省份">
        <el-select v-model="searchForm.province" filterable>
          <el-option v-for="(item, index) in provinceList" :label="item" :value="item" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单位">
        <el-select v-model="searchForm.unit" filterable>
          <el-option v-for="(item, index) in unit" :label="item.name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="get_data">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="searchReset">清空</el-button>
      </el-form-item>
       <el-form-item>
        <el-button @click="exportExtcel">导出</el-button>
      </el-form-item>
    </el-form>

    <div>
      <h2>数据表（共{{ tableData.length }}条数据）</h2>
    </div>
    <el-table :data="tableData" border class="table" show-summary :summary-method="getSummaries" max-height="440px" fixed
      v-loading="table_loading"  :header-cell-style="{ 'background-color': '#f6f6f6' }">
      <el-table-column align="center" prop="username" label="用户名"></el-table-column>
      <el-table-column align="center" prop="region" label="区域"></el-table-column>
      <el-table-column align="center" prop="province" label="省份"></el-table-column>
      <el-table-column align="center" prop="unit" label="单位名"></el-table-column>
      <el-table-column align="center" prop="department" label="科室"></el-table-column>
      <el-table-column align="center" prop="group" label="小组"></el-table-column>
      <el-table-column align="center" prop="report_type_1" label="甲状腺功能报告解读次数">
        <template slot-scope="scope">
          <span class="link" @click="to_anomaly_index('甲状腺功能报告解读次数', '甲状腺疾病', scope.row,1)">{{ scope.row.report_type_1
            }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="report_type_2" label="心脏功能报告解读次数">
        <template slot-scope="scope">
          <span class="link" @click="to_anomaly_index('心脏功能报告解读次数', '心脏疾病', scope.row,2)">{{ scope.row.report_type_2
            }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="report_type_3" label="性激素报告解读次数">
        <template slot-scope="scope">
          <span class="link" @click="to_anomaly_index('性激素报告解读次数', '性激素', scope.row,3)">{{ scope.row.report_type_3
            }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="report_type_4" label="肿瘤报告解读次数">
        <template slot-scope="scope">
          <span class="link" @click="to_anomaly_index('肿瘤报告解读次数', '肿瘤疾病', scope.row,4)">{{ scope.row.report_type_4
            }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="report_type_5" label="其他报告解读次数">
        <template slot-scope="scope">
          <span  >{{ scope.row.report_type_5
            }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="testing_platform_1" label="罗检测次数">
        <template slot-scope="scope">
          <span class="link" @click="to_report_type('罗检测次数', '罗', scope.row)">{{ scope.row.testing_platform_1 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="testing_platform_2" label="雅检测次数">
        <template slot-scope="scope">
          <span class="link" @click="to_report_type('雅检测次数', '雅', scope.row)">{{ scope.row.testing_platform_2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="testing_platform_3" label="贝检测次数">
        <template slot-scope="scope">
          <span class="link" @click="to_report_type('贝检测次数', '贝', scope.row)">{{ scope.row.testing_platform_3 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="testing_platform_4" label="西检测次数">
        <template slot-scope="scope">
          <span class="link" @click="to_report_type('西检测次数', '西', scope.row)">{{ scope.row.testing_platform_4 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="testing_platform_5" label="迈检测次数">
        <template slot-scope="scope">
          <span class="link" @click="to_report_type('迈检测次数', '迈', scope.row)">{{ scope.row.testing_platform_5 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="testing_platform_6" label="其他平台检测次数">
        <template slot-scope="scope">
          <span class="link" @click="to_report_type('其他平台检测次数', '其他', scope.row)">{{ scope.row.testing_platform_6 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="factor_1" label="生理因素次数">
        <template slot-scope="scope">
          <span class="link" @click="to_disease_factors('生理因素次数', '生理因素', scope.row,'factor_1')">{{ scope.row.factor_1 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="factor_2" label="药物因素次数">
        <template slot-scope="scope">
          <span class="link" @click="to_disease_factors('药物因素次数', '药物因素', scope.row,'factor_2')">{{ scope.row.factor_2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="factor_3" label="疾病因素次数">
        <template slot-scope="scope">
          <span class="link" @click="to_disease_factors('疾病因素次数', '疾病因素', scope.row,'factor_3')">{{ scope.row.factor_3 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="factor_4" label="其他因素次数" >
        <template slot-scope="scope">
          <span class="link" @click="to_disease_factors('其他因素次数', '其他因素', scope.row,'factor_4')">{{ scope.row.factor_4 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="disease_1" label="甲状腺疾病次数">
        <template slot-scope="scope">
          <span class="link" @click="to_disease_number('甲状腺疾病次数', '甲状腺疾病', scope.row)">{{ scope.row.disease_1 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="disease_2" label="心脏疾病次数">
        <template slot-scope="scope">
          <span class="link" @click="to_disease_number('心脏疾病次数', '心脏疾病', scope.row)">{{ scope.row.disease_2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="disease_3" label="肿瘤疾病次数">
        <template slot-scope="scope">
          <span class="link" @click="to_disease_number('肿瘤疾病次数', '肿瘤疾病', scope.row)">{{ scope.row.disease_3 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="disease_4" label="性激素疾病次数">
        <template slot-scope="scope">
          <span class="link" @click="to_disease_number('性激素疾病次数', '性激素', scope.row)">{{ scope.row.disease_4 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="disease_5" label="其他疾病次数"></el-table-column>
      <el-table-column align="center" prop="drug_analysis_1" label="用药导致"></el-table-column>
      <el-table-column align="center" prop="drug_analysis_2" label="疾病导致"></el-table-column>
      <el-table-column align="center" prop="drug_analysis_3" label="不良习惯导致"></el-table-column>
      <el-table-column align="center" prop="drug_analysis_4" label="干扰因素导致"></el-table-column>
    </el-table>
    <!--    <el-pagination-->
    <!--        background-->
    <!--        layout="prev, pager, next"-->
    <!--        :total="1000">-->
    <!--    </el-pagination>-->
    <div style="height: 11vh"></div>
  </div>
</template>

<script>
import { options } from "@/assets/issue";
import { get_unit } from "@/api/unit";
import { get_data } from "@/api/DataSearch";
import request from "@/utils/request";
import axios from "axios";
import user from "@/store/modules/user";

export default {
  name: "data_search",
  data() {
    return {
      searchForm: {
        timeZone: '',
        region: '',
        province: '',
        unit: ''
      },
      tableData: [],
      options: options,
      provinceList: [
        "北京市", "天津市", "上海市", "重庆市",
        "河北省", "山西省", "辽宁省", "吉林省", "黑龙江省",
        "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省",
        "河南省", "湖北省", "湖南省", "广东省", "海南省",
        "四川省", "贵州省", "云南省", "陕西省", "甘肃省", "青海省",
        "台湾省", "内蒙古自治区", "广西壮族自治区", "西藏自治区",
        "宁夏回族自治区", "新疆维吾尔自治区", "香港特别行政区", "澳门特别行政区"
      ],
      unit: [],
      page: 1,
      page_size: 10,
      table_loading: false
    }
  },
  methods: {
    searchReset() {
      this.searchForm = { timeZone: '', type: [] }
    },
    get_unit_data() {
      this.table_loading = true
      // get_unit().then(res => {
      //   this.table_loading = false
      //   const { data } = res
      //   if (data['code'] === 200) {
      //     this.unit = data['data']
      //   }
      // })
      request.get("/admin/unit",{
        params: {
          page: 1,
          page_size: 1000,
        }
      }).then((data) => {
        this.table_loading = false
        if (data["code"] === 200) {
          this.unit = data["data"];
        }
      });
    },
    exportExtcel() {
      // if (this.leftForm.timeZone !== '') {
      //   this.leftForm.start_time = this.leftForm.timeZone[0]
      //   this.leftForm.end_time = this.leftForm.timeZone[1]
      // }
      // const params = {
      //   page_size: this.page_size,
      //   ...this.leftForm,
      //   page: this.page,
      //   unit: this.leftForm.unit.join(','),
      //   access: this.leftForm.access.join(',')
      // }
      axios.get("/api/admin/data/export-recent-other-diseases/", {
        // params: params,
      }).then((res) => {
        
        if (res.data.code === 200) {
           
          const downloadUrl = "/api/static/export/disease_data/" + res.data.name;

          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = res.data.name; // 设置下载文件名
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a); // 下载完成后移除a标签
        }
      })
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]));
        if ([1, 2, 3, 4, 5].indexOf(index) !== -1) {
          sums[index] = ''
          return
        }
        sums[index] = values.reduce((prev, curr) => {
          return prev + curr;
        }, 0);
        if (index === 0) {
          sums[index] = `共${data.length}人`
        }
      });
      // console.log(sums, '-------------')
      return sums
    },
    to_anomaly_index(title, name, row,report_type) {
      // const conversation_ids = row['query_record'][name] || []
      this.$router.push({
        name: 'anomaly_index',
        // params: { title, username: row.username, conversation_ids }
        params:{user_id:row.user_id,title,username:row.username,name,report_type}
      })
    },
    to_disease_factors(title, name, row, factor_name) {
      // console.log(title, name, row);
      
      // const conversation_ids = row['query_record'][name] || []
      this.$router.push({
        name: 'disease_factors',
        params: {title, username: row.username, user_id:row.user_id, name,factor_name }
      })
    },
    to_disease_number(title, name, row) {
      // const conversation_ids = row['query_record'][name] || []
      this.$router.push({
        name: 'disease_number',
        params: {user_id:row.user_id,title, username: row.username, name }
      })
    },
    to_report_type(title, name, row) {
      // const conversation_ids = row['query_record'][name] || []
      this.$router.push({
        name: 'report_type',
        params: { title, username: row.username,user_id:row.user_id, name }
      })
    },
    get_data() {
      this.table_loading = true
      get_data(this.searchForm.region, this.searchForm.province, this.searchForm.unit, this.searchForm.timeZone).then(res => {
        const { data } = res
        this.table_loading = false
        if (data['code'] === 200) {
          // console.log(res, "res");

          this.tableData = data['data']
          
            this.$forceUpdate()

        }
      })
    },
  },
  mounted() {
    this.get_unit_data()
    // this.get_data()
  },
  beforeUnmount() {
  },
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
  overflow-y: auto;
}

.table ::-webkit-scrollbar {
  width: 11px !important;
  height: 11px !important;
}

.link {
  color: #266FFF;
  cursor: pointer;
}
</style>